<div class="expired-page">

  <!-- Header -->
  <header class="expired-header">
    <!-- Upgrade Banner (same position as trial banner in main header) -->
    <div class="expired-upgrade-banner">
      <span class="expired-upgrade-banner__msg">Your trial has expired. Upgrade your account to continue using Enact Solar.</span>
      <button *ngIf="!upgradeRequestSent"
              class="expired-upgrade-banner__btn"
              (click)="requestUpgrade()"
              [disabled]="upgradeRequestLoading">
        {{ upgradeRequestLoading ? 'Sending...' : 'Request Upgrade' }}
      </button>
      <span *ngIf="upgradeRequestSent" class="expired-upgrade-banner__sent">
        <i class="fa fa-check-circle"></i> Request sent! Our team will reach out shortly.
      </span>
    </div>

    <!-- Logo + nav row -->
    <div class="expired-header-main">
      <a href="https://www.enact.solar" target="_blank">
        <img class="logo" [src]="logo" alt="Enact Solar" />
      </a>
      <div class="header-right">
        <div class="header-social">
          <a href="https://www.facebook.com/Enact.Solar" target="_blank" rel="noopener noreferrer" title="Follow on Facebook"><i class="fa fa-facebook"></i></a>
          <a href="https://twitter.com/ENACTSOLAR" target="_blank" rel="noopener noreferrer" title="Follow on X"><i class="fa fa-twitter"></i></a>
          <a href="https://www.linkedin.com/company/enact-systems-inc" target="_blank" rel="noopener noreferrer" title="Follow on LinkedIn"><i class="fa fa-linkedin"></i></a>
          <a href="https://www.youtube.com/@enactsolar/" target="_blank" rel="noopener noreferrer" title="Follow on Youtube"><i class="fa fa-youtube"></i></a>
          <a href="https://www.instagram.com/enact_solar/" target="_blank" rel="noopener noreferrer" title="Follow on Instagram"><i class="fa fa-instagram"></i></a>
        </div>
        <a class="header-support" [href]="'mailto:' + supportEmail">Support</a>
        <div class="header-user" (click)="toggleUserMenu()">
          <span class="header-username">{{ username }}</span>
          <i class="fa fa-chevron-down header-chevron"></i>
          <div class="user-dropdown" *ngIf="showUserMenu">
            <button class="user-dropdown-item" (click)="logout()">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Content -->
  <div class="expired-content">
    <div class="expired-card">
      <div class="expired-icon">
        <i class="fa fa-clock-o"></i>
      </div>
      <h2>Your Trial Has Expired</h2>
      <p>
        Your 7-day free trial ended on <strong>{{ trialEndDate }}</strong>.
        To continue using Enact Solar, please contact us to upgrade your account.
      </p>
      <button *ngIf="!upgradeRequestSent"
              class="support-link"
              (click)="requestUpgrade()"
              [disabled]="upgradeRequestLoading">
        {{ upgradeRequestLoading ? 'Sending...' : 'Request Upgrade' }}
      </button>
      <span *ngIf="upgradeRequestSent" class="upgrade-sent-msg">
        <i class="fa fa-check-circle"></i> Request sent! Our team will reach out shortly.
      </span>
    </div>
  </div>

</div>
